import React from "react";
import "./footer.css";
import { i18n } from "../translate/i18n";

import ImgLogo from "../../assets/LogoTomio.png";

export const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__container container">
        <div className="container__logo">
          <img
            src={ImgLogo}
            alt="Logo da página nome Tomio"
            className="footer__logo"
          />
        </div>

        <ul className="footer__list">
          <li>
            <a href="#about" className="footer__link">
              {i18n.t("header.about")}
            </a>
          </li>
          <li>
            <a href="#skills" className="footer__link">
              {i18n.t("header.skills")}
            </a>
          </li>
          <li>
            <a href="#services" className="footer__link">
              {i18n.t("header.services")}
            </a>
          </li>
        </ul>

        <div className="footer__social">
          <div className="footer__social">
            <a
              href="https://github.com/Jtomio"
              className="footer__social-icon"
              target="_blank"
              rel="noreferrer"
            >
              <i className="uil uil-github-alt"></i>
            </a>
            <a
              href="mailto:medriase@gmail.com"
              className="footer__social-icon"
              target="_blank"
              rel="noreferrer"
            >
              <i className="uil uil-envelope"></i>
            </a>
            <a
              href="https://www.instagram.com/jtomio3/"
              className="footer__social-icon"
              target="_blank"
              rel="noreferrer"
            >
              <i className="uil uil-instagram"></i>
            </a>
          </div>
        </div>
        <span className="footer__copy">
          &#169;Tomio. {i18n.t("footer.copy")}
        </span>
      </div>
    </footer>
  );
};
